import { CHAPERON_SHARE_URL } from "../const/paths"
import { riskProfile, safetyPercentage } from "./helpers"

// The chaperon.app link for a place's Analysis page. It unfurls with the
// place's safety-level card and redirects people to this site.
export function buildShareUrl(slug) {
    return slug
        ? `${CHAPERON_SHARE_URL}/analysis/${encodeURIComponent(slug)}`
        : CHAPERON_SHARE_URL
}

// Same wording as the share page's title, e.g. "Kingston, Jamaica: OKAY".
// Shares show the safety level, never a numerical score.
export function shareTitle(place) {
    const where =
        place?.country && place.country !== place.name
            ? `${place.name}, ${place.country}`
            : place?.name || "Chaperon"
    const score = place?.overall_safety
    if (score === null || score === undefined || Number.isNaN(Number(score))) {
        return where
    }
    return `${where}: ${riskProfile(safetyPercentage(score)).toUpperCase()}`
}
